var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center text-pink mt-5"},[_vm._v("Admin")])])
}]

export { render, staticRenderFns }